import {createSlice} from "@reduxjs/toolkit";

export const reducerName = "credits";
export const initialState = {
	newCredit: {
		id: 0,
		clientUserId: 0,
		creditPrice: "",
		paymentRequest: {
			amount: "",
			type: "square"
		}
	},
	isChangeCreditCard: false,
	paymentType: "",
	isCreditPayment: false,
	appointmentData: {
		promo: '',
		isMiss: false,
		isAgree: false,
		vetPrice: '',
	},
	creditsAmount: 0,
	expirationDate: "",
	creditRequests: [],
	creditType: "ADVICE",
	allCards: [],
	selectedCard: null,
};

const creditsReducer = createSlice({
	name: reducerName,
	initialState,
	reducers: {
		setCredit: (state, action) => ({
			...state,
			newCredit: action.payload
		}),
		setAllCards: (state, action) => ({
			...state,
			allCards: action.payload
		}),
		setIsChangeCreditCard: (state, action) => ({
			...state,
			isChangeCreditCard: action.payload
		}),
		setPaymentType: (state, action) => ({
			...state,
			paymentType: action.payload
		}),
		setIsCreditPayment: (state, action) => ({
			...state,
			isCreditPayment: action.payload
		}),
		changeAppointmentData: (state, action) => ({
			...state,
			appointmentData: action.payload
		}),
		setSelectedCard: (state, action) => ({
			...state,
			selectedCard: action.payload
		}),
		setCreditsAmount: (state, action) => ({
			...state,
			creditsAmount: action.payload
		}),
		setCreditsExpirationDate: (state, action) => ({
			...state,
			expirationDate: action.payload
		}),
		setCreditRequests: (state, action) => ({
			...state,
			creditRequests: action.payload
		}),
		reduceCreditsAmount: (state) => ({
			...state,
			creditsAmount: state.creditsAmount - 1
		}),
		setCreditType: (state, action) => ({
			...state,
			creditType: action.payload
		}),
		clearCredits: () => initialState,
	}
});

export default creditsReducer.reducer;
export const {
	setCredit,
	setCreditsAmount,
	setCreditsExpirationDate,
	setCreditRequests,
	reduceCreditsAmount,
	setCreditType,
	setIsChangeCreditCard,
	setIsCreditPayment,
	changeAppointmentData,
	setSelectedCard,
	setAllCards,
	setPaymentType,
	clearCredits
} = creditsReducer.actions;
